module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-$5-off-0a481bd0dd1d3050508dcc5ef858ece5.png";